import React, { useContext } from 'react';
import { OrderContext } from '../../context/OrderContext';
import OrderUploadHandler from './files/orderUploadHandler';
import { settings } from './settings/settings';
import OrderContactPerson from '../../components/orderElements/orderContactPerson';
import OrderContracted from '../../components/orderElements/orderContracted';
import { PiDotDuotone } from "react-icons/pi";


export default function OrderApplication() {
    const { order } = useContext(OrderContext);

    const mapObjectToText = (object, options) => {
        if (!object) return '-';
        let array
        if (typeof object === 'object' && !Array.isArray(object)) {
            array = Object.entries(object).map((t) => {
                return { [t[0]]: t[1] };
            });
        } else {
            array = object;
        }

        const keys = array.map((t) => Object.keys(t)[0])
        if (!keys || keys.length === 0) return '-';
        const ids = keys.map((t) => options.find((o) => o.id === t)).filter((e) => e);
        if (!ids || ids.length === 0) return '-';
        const names = ids.map((i) => i.name);
        if (!names || names.length === 0) return '-';
        const values = names.filter((n) => n.length > 0);
        if (!values || values.length === 0 ) return '-';
        return values;
    }

    const getOptions = (object, options) => {
        if (!object) return '-';
        const option = options.find(
            (o) => o.id === object
        )
        if (!option) return '-';
        return option.name;
    }


    const getTextField = (label, text) => {
        if (!text || text === "-" || text === '') return;

        return (
            <div className="p-4  sm:grid sm:grid-cols-3 sm:px-0">
                <div className="text-sm/6 font-medium text-gray-900 ">{label}</div>
                <div className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                    {Array.isArray(text) ? text?.map((t) => {
                        return (
                            <div key={t} className='truncate flex'>
                                <PiDotDuotone className={"h-6 w-6"} /> <span>{t}</span>
                            </div>
                        )
                    }) : text}
                </div>
            </div>
        );
    };



    const getDatesField = (label, text) => {

        if(typeof text === "undefined" || text === "-") {return;}

        text = new Date(Number(text));
        text = text?.toLocaleString("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        })

        return (
            <div className="p-4  sm:grid sm:grid-cols-3 sm:px-0">
                <div className="text-sm/6 font-medium text-gray-900 ">{label}</div>
                <div className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                    <div key={text} className='truncate'>
                        {text} Uhr
                    </div>
                </div>
            </div>
        );
    };


    const getDownload = () => {
        return (
            <div className="px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <div className="text-sm/6 py-6  font-medium text-gray-900 ">Dokumente</div>
                <div className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                    <div className='sm:col-span-2 sm:px-0'>
                        <OrderUploadHandler />
                    </div>
                </div>
            </div>
        )
    };


    return (
        <div>
            <div className='border border-gray-500 rounded-lg bg-white overflow-hidden mb-2 sm:mb-4 md:mb-8'>
                <div className={'mt-2 lg:p-6 p-4'}>

                    <div className={'grid col-span-1 mb-12 lg:grid-cols-2'}>
                        <OrderContactPerson/>

                        {(order.stage !== "draft" && order.stage !== "inTender") && (
                            <OrderContracted/>
                        )}
                    </div>

                    <div className="px-4 mb-6 sm:px-0">
                        <h3 className="text-lg font-semibold text-gray-900">Auftragsinformationen</h3>
                        <p className="mt-1 text-sm/6 text-gray-600/60">Hier finden Sie sämtliche Details zum Auftrag.</p>
                    </div>

                    <div>
                        <div className="divide-y divide-gray-300">
                            {getTextField(
                                settings.name.label,
                                order?.planDetails?.name ? order?.planDetails.name : '-'
                            )}
                            {getTextField(
                                "Auftragsnummer", order?.planId
                            )}
                            {getDatesField(
                                "Erstellt am", order?.createdAt
                            )}
                            {getTextField(
                                settings.community.label,
                                order?.planDetails?.community?.name ? order?.planDetails.community?.name : '-'
                            )}
                            {getTextField(
                                settings.communityKey.label,
                                order?.planDetails?.community?.id ? order?.planDetails.community?.id : '-'
                            )}
                            {getTextField(
                                settings.planType.label,
                                mapObjectToText(order?.planDetails?.planType, settings.planType.options)
                            )}
                            {getTextField(
                                settings.orderTypes.label,
                                getOptions(order?.planDetails?.orderTypes, settings.orderTypes.options)
                            )}
                            {getTextField(
                                settings.deadline.label,
                                order?.planDetails?.deadline?.date
                                    ? order?.planDetails.deadline.date
                                    : '-'
                            )}
                            {getTextField(
                                settings.plotArea.label,
                                order?.planDetails?.plotArea
                            )}
                            {getTextField(
                                settings.legalPlanStatus.label,
                                getOptions(order?.planDetails?.legalPlanStatus, settings.legalPlanStatus.options)
                            )}
                            {getTextField(
                                settings.depthOfCoverage.label,
                                getOptions(order?.planDetails?.depthOfCoverage, settings.depthOfCoverage.options)
                            )}
                            {getTextField(
                                settings.textualDeterminations.label,
                                getOptions(order?.planDetails?.textualDeterminations, settings.textualDeterminations.options)
                            )}
                            {getTextField(
                                settings.procedure.label,
                                getOptions(order?.planDetails?.procedure, settings.procedure.options)
                            )}
                            {getTextField(
                                settings.requestedXPlanVersion.label,
                                getOptions(order?.planDetails?.requestedXPlanVersion, settings.requestedXPlanVersion.options)
                            )}
                            {getTextField(
                                settings.projection.label,
                                getOptions(order?.planDetails?.projection, settings.projection.options)
                            )}
                            {getTextField(
                                settings.additionalInformation.label,
                                order?.planDetails?.additionalInformation ? order?.planDetails.additionalInformation : '-'
                            )}
                            {getTextField(
                                settings.otherRequirements.label,
                                mapObjectToText(order?.planDetails?.otherRequirements, settings.otherRequirements.options)
                            )}
                           {getDownload(
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
